import React from 'react';

interface IconProps {
  name: string;
  size?: number;
  className?: string;
}

const ICONS: Record<string, React.ReactNode> = {
  user: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2" />
    </>
  ),
  briefcase: (
    <>
      <rect x="2" y="7" width="20" height="14" rx="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </>
  ),
  graduation: (
    <>
      <path d="M2 10l10-5 10 5-10 5z" />
      <path d="M6 12v5c3 3 9 3 12 0v-5" />
    </>
  ),
  wrench: (
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  ),
  rocket: (
    <>
      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
      <path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
      <circle cx="12" cy="15" r="2" />
    </>
  ),
  handshake: (
    <>
      <path d="M21 10l-6-5-4 4" />
      <path d="M3 14l6 5 4-4" />
      <path d="M9 9l-4-4" />
      <path d="M15 15l4 4" />
    </>
  ),
  trophy: (
    <>
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
      <path d="M4 22h16" />
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2z" />
    </>
  ),
  mail: (
    <>
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </>
  ),
  star: (
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </>
  ),
  check: (
    <polyline points="20 6 9 17 4 12" />
  ),
  refresh: (
    <>
      <polyline points="23 4 23 10 17 10" />
      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
    </>
  ),
  sparkles: (
    <>
      <path d="M12 3l1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3z" />
      <path d="M19 13l.5 1.5L21 15l-1.5.5L19 17l-.5-1.5L17 15l1.5-.5L19 13z" />
      <path d="M5 10l.5 1L7 11.5 5.5 12 5 13l-.5-1L3 11.5 4.5 11 5 10z" />
    </>
  ),
  leaf: (
    <>
      <path d="M11 20A7 7 0 0 1 9.8 6.9C15.5 4.9 17 3.5 19 2c1 2 2 4.5 2 8 0 5-2 10-7 10" />
      <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" />
    </>
  ),
  volunteer: (
    <>
      <path d="M12 7c-2-3-6-2-6 2 0 3 6 8 6 8s6-5 6-8c0-4-4-5-6-2z" />
      <path d="M4 13l-2 3" />
      <path d="M20 13l2 3" />
    </>
  ),
  certificate: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9 12l2 2 4-4" />
    </>
  ),
  chat: (
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  ),
  book: (
    <>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      <path d="M12 2v7l3-1.5L18 9V2" />
    </>
  ),
  brain: (
    <>
      <path d="M12 4a4 4 0 0 0-4-4C6 0 4 2 4 4c0 1.5.7 2.8 1.8 3.7C4.6 9 4 10.5 4 12c0 3 2 5 4 5v3" />
      <path d="M12 4a4 4 0 0 1 4-4c2 0 4 2 4 4 0 1.5-.7 2.8-1.8 3.7C19.4 9 20 10.5 20 12c0 3-2 5-4 5v3" />
      <path d="M8 20h8" />
    </>
  ),
  mobile: (
    <>
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
      <line x1="12" y1="18" x2="12.01" y2="18" />
    </>
  ),
  web: (
    <>
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="12" y1="17" x2="12" y2="21" />
    </>
  ),
  compass: (
    <>
      <circle cx="12" cy="12" r="10" />
      <path d="M16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36 6.36-2.12z" />
    </>
  ),
  chain: (
    <>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </>
  ),
  cloud: (
    <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
  ),
  database: (
    <>
      <ellipse cx="12" cy="5" rx="9" ry="3" />
      <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
    </>
  ),
  python: (
    <>
      <path d="M9 4h6a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H9a3 3 0 0 0-3 3v3a3 3 0 0 0 3 3h6" />
      <path d="M15 20H9a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h6a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3z" />
    </>
  ),
  flash: (
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10" />
  ),
  laptop: (
    <>
      <rect x="2" y="3" width="20" height="13" rx="2" />
      <path d="M6 20h12" />
      <path d="M10 20l-1 2h6l-1-2" />
    </>
  ),
  un: (
    <>
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2z" />
      <path d="M4 8l2 1" />
      <path d="M20 8l-2 1" />
      <path d="M4 16l2-1" />
      <path d="M20 16l-2-1" />
    </>
  ),
};

const Icon: React.FC<IconProps> = ({ name, size = 16, className }) => {
  const paths = ICONS[name];
  if (!paths) return null;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {paths}
    </svg>
  );
};

export default Icon;
export type { IconProps };

export const UserIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="user" {...props} />;
export const BriefcaseIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="briefcase" {...props} />;
export const GraduationIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="graduation" {...props} />;
export const WrenchIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="wrench" {...props} />;
export const RocketIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="rocket" {...props} />;
export const HandshakeIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="handshake" {...props} />;
export const TrophyIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="trophy" {...props} />;
export const GlobeIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="globe" {...props} />;
export const MailIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="mail" {...props} />;
export const StarIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="star" {...props} />;
export const SearchIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="search" {...props} />;
export const CheckIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="check" {...props} />;
export const RefreshIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="refresh" {...props} />;
export const SparklesIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="sparkles" {...props} />;
export const LeafIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="leaf" {...props} />;
export const VolunteerIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="volunteer" {...props} />;
export const CertificateIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="certificate" {...props} />;
export const ChatIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="chat" {...props} />;
export const BookIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="book" {...props} />;
export const BrainIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="brain" {...props} />;
export const MobileIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="mobile" {...props} />;
export const WebIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="web" {...props} />;
export const CompassIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="compass" {...props} />;
export const ChainIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="chain" {...props} />;
export const CloudIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="cloud" {...props} />;
export const DatabaseIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="database" {...props} />;
export const PythonIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="python" {...props} />;
export const FlashIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="flash" {...props} />;
export const LaptopIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="laptop" {...props} />;
export const UnIcon: React.FC<Omit<IconProps, 'name'>> = (props) => <Icon name="un" {...props} />;
